import { BsUtil } from "../util";
import { Retriever } from "../retriever";
import { BFFGateway } from "../dependencies";
import { Parser } from "../parser";
import { LibConfig, setLibConfig } from "../config";
export var init = function (config) {
    if (Object.isFrozen(LibConfig)) {
        // Throw error ?
        return BsUtil.getInstance();
    }
    setLibConfig(config);
    Object.freeze(LibConfig);
    return new BsUtil(new Retriever(new BFFGateway()), new Parser());
};
export var getInstance = function () {
    return BsUtil.getInstance();
};
//# sourceMappingURL=init.js.map